/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_exercise_rights = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`To exercise any of these rights, please contact us at ${i?.email}. We will respond to your request within 30 days.`)
};

const es_privacy_exercise_rights = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Para ejercer cualquiera de estos derechos, contáctanos en ${i?.email}. Responderemos a tu solicitud dentro de 30 días.`)
};

const de_privacy_exercise_rights = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Um eines dieser Rechte auszuüben, kontaktieren Sie uns bitte unter ${i?.email}. Wir werden Ihre Anfrage innerhalb von 30 Tagen beantworten.`)
};

const nl_privacy_exercise_rights = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Om een van deze rechten uit te oefenen, neem contact met ons op via ${i?.email}. We zullen binnen 30 dagen op uw verzoek reageren.`)
};

const fr_privacy_exercise_rights = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pour exercer l’un de ces droits, veuillez nous contacter à ${i?.email}. Nous répondrons à votre demande dans les 30 jours.`)
};

const it_privacy_exercise_rights = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Per esercitare uno qualsiasi di questi diritti, contattaci a ${i?.email}. Risponderemo alla tua richiesta entro 30 giorni.`)
};

const pt_br2_privacy_exercise_rights = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Para exercer qualquer um desses direitos, entre em contato conosco em ${i?.email}. Responderemos à sua solicitação em 30 dias.`)
};

const pt_privacy_exercise_rights = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Para exercer qualquer um destes direitos, contacte-nos em ${i?.email}. Responderemos ao seu pedido no prazo de 30 dias.`)
};

const ja_privacy_exercise_rights = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`これらの権利を行使するには、${i?.email}までご連絡ください。30日以内にリクエストに対応します。`)
};

const zh_privacy_exercise_rights = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`要行使这些权利，请通过${i?.email}联系我们。我们将在30天内回复您的请求。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ email: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_exercise_rights = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_exercise_rights(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_exercise_rights", locale)
	if (locale === "en") return en_privacy_exercise_rights(inputs)
	if (locale === "es") return es_privacy_exercise_rights(inputs)
	if (locale === "de") return de_privacy_exercise_rights(inputs)
	if (locale === "nl") return nl_privacy_exercise_rights(inputs)
	if (locale === "fr") return fr_privacy_exercise_rights(inputs)
	if (locale === "it") return it_privacy_exercise_rights(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_exercise_rights(inputs)
	if (locale === "pt") return pt_privacy_exercise_rights(inputs)
	if (locale === "ja") return ja_privacy_exercise_rights(inputs)
	return zh_privacy_exercise_rights(inputs)
};